import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { FormattedMessage } from '../../../../util/reactIntl';
import { checkElephantModalOpen } from '../../../../util/data';

import { IconSpinner } from '../../../../components';
import { OutsideClickHandler } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import {
  createSpacePost,
  deleteCirclePost,
  followUnfollowPost,
  pinPostToHighlights,
  toggleCreatePost,
  toggleEditPost,
  toggleReportContent,
  unpinPostFromHighlights,
} from '../../CircleCommunityPage.duck';

import css from './CircleFeedCard.module.css';

const PostOptionsMenu = props => {
  const {
    feedData,
    currentCommunityMember,
    handleSaveUnsave,
    userRoleInGroup,
    isOwnPost,
    currentUser,
    requestDeletePost,
    onPostDeleted = () => {},
    onSetElephantVerificationModal = () => {},
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const isPostDeletedFn = typeof onPostDeleted == 'function';

  const {
    id: postId,
    name,
    display_title,
    is_comments_closed,
    policies,
    is_liking_enabled,
    comment_count,
    user_likes_count,
    is_liked,
    tiptap_body,
    space,
    author,
    body_plain_text,
    bookmark_id,
    created_at,
    cover_image = '',
    post_follower_id = null,
    is_pinned_at_top_of_space,
    is_pinned,
    is_pinned_to_highlights,
    poll = {},
  } = feedData || {};
  const { content = [] } = tiptap_body?.body?.content?.[0] || {};
  const { id: spaceId, name: spaceName } = space || {};
  const { id: authorId, community_member_id, name: authorName, avatar_url, roles, headline } =
    author || {};
  const { roles: currentUserRoles, id: currentUserId } = currentCommunityMember || {};
  const dispatch = useDispatch();
  const isDeletingPost = requestDeletePost === postId;
  const isOptionVisible =
    community_member_id === currentUserId || currentUserRoles?.admin || currentUserRoles?.moderator;
  const isPollPost = poll?.id;
  const isPinnedAtTop = Boolean(is_pinned_at_top_of_space || is_pinned);
  const canEditPost =
    !isPollPost && (isOwnPost || currentUserRoles?.admin || userRoleInGroup === 'admin');
  const handleEditPost = () => {
    dispatch(toggleEditPost(feedData));
    dispatch(toggleCreatePost(true));
    setIsOpen(!isOpen);
  };

  const handleDeletePost = async () => {
    if (isDeletingPost) {
      return;
    }
    const response = await dispatch(deleteCirclePost(postId, spaceId));
    if (response?.success) {
      setIsOpen(false);
      onPostDeleted(feedData);
    }
  };

  const saveScrollBeforeElephantModal = () => {
    if (typeof window !== 'undefined') {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      window.sessionStorage.setItem('topbarModalScrollPosition', scrollY);
    }
  };

  const handleFlaggedContent = () => {
    if (checkElephantModalOpen(currentUser)) {
      saveScrollBeforeElephantModal();
      onSetElephantVerificationModal(true);
      return;
    }
    dispatch(toggleReportContent(feedData));
    setIsOpen(!isOpen);
  };

  const handleFollowUnfollow = () => {
    dispatch(followUnfollowPost(postId, spaceId, post_follower_id));
    setIsOpen(!isOpen);
  };

  const handlePinAtTop = () => {
    const apiParams = {
      bodyParam: {
        is_pinned: !isPinnedAtTop,
      },
    };
    dispatch(createSpacePost(apiParams, spaceId, postId));
    setIsOpen(!isOpen);
  };

  const handlePinToHighlights = () => {
    if (is_pinned_to_highlights) {
      dispatch(unpinPostFromHighlights(postId, spaceId));
    } else {
      dispatch(pinPostToHighlights(postId, spaceId));
    }
    setIsOpen(!isOpen);
  };

  const handleCloseComment = () => {
    const apiParams = {
      bodyParam: {
        is_comments_closed: !is_comments_closed,
      },
    };
    dispatch(createSpacePost(apiParams, spaceId, postId));
    setIsOpen(!isOpen);
  };

  const isGroupModerator = ['admin', 'moderator'].includes(userRoleInGroup);

  return (
    <div className={css.dropdownDots}>
      <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
        <span
          data-testid="post-dropdowndots"
          onClick={() => setIsOpen(!isOpen)}
          className={css.iconWrapper}
        >
          <ProfileIconCard type="dot" />
        </span>
        {isOpen ? (
          <div className={css.dropdownMenu}>
            <ul>
              <li
                data-testid="post-options-save-unsave-post"
                onClick={() => {
                  if (checkElephantModalOpen(currentUser)) {
                    saveScrollBeforeElephantModal();
                    onSetElephantVerificationModal(true);
                    return;
                  }
                  handleSaveUnsave();
                }}
              >
                {bookmark_id ? (
                  <FormattedMessage id="CircleFeedPage.unsavePost" />
                ) : (
                  <FormattedMessage id="CircleFeedPage.savePost" />
                )}
              </li>
              {canEditPost ? (
                <li onClick={handleEditPost}>
                  <FormattedMessage id="CircleFeedPage.editPost" />
                </li>
              ) : null}
              <li data-testid="post-options-report-post" onClick={handleFlaggedContent}>
                <FormattedMessage id="CircleFeedPage.report" />
              </li>
              {/* <>

                <li className={css.mobileLink}>Share</li>
              </> */}
              {['admin'].includes(userRoleInGroup) || isOwnPost ? (
                <li
                  className={isDeletingPost ? css.disabledMenuItem : null}
                  data-testid="post-options-delete-post"
                  onClick={handleDeletePost}
                >
                  {isDeletingPost ? (
                    <>
                      <IconSpinner className={css.menuItemSpinner} />
                      <FormattedMessage id="CircleFeedPage.deletingPost" />
                    </>
                  ) : (
                    <FormattedMessage id="CircleFeedPage.deletePost" />
                  )}
                </li>
              ) : null}
              {/* {isOptionVisible ? (
                <li>
                  <hr />
                </li>
              ) : null} */}
              {/* <li onClick={handleFollowUnfollow}>
                {post_follower_id ? (
                  <FormattedMessage id="CircleFeedPage.unfollowPost" />
                ) : (
                  <FormattedMessage id="CircleFeedPage.followPost" />
                )}
              </li> */}
              {isGroupModerator ? (
                <li onClick={handlePinToHighlights}>
                  {is_pinned_to_highlights ? (
                    <FormattedMessage id="CircleFeedPage.unpinFromHighlights" />
                  ) : (
                    <FormattedMessage id="CircleFeedPage.pinToHighlights" />
                  )}
                </li>
              ) : null}
              {['admin'].includes(userRoleInGroup) ? (
                <li onClick={handlePinAtTop}>
                  {isPinnedAtTop ? (
                    <FormattedMessage id="CircleFeedPage.unpinFromTop" />
                  ) : (
                    <FormattedMessage id="CircleFeedPage.pinToTop" />
                  )}
                </li>
              ) : null}
              {['admin'].includes(userRoleInGroup) || isOwnPost ? (
                <li onClick={handleCloseComment}>
                  {is_comments_closed ? (
                    <FormattedMessage id="CircleFeedPage.openComment" />
                  ) : (
                    <FormattedMessage id="CircleFeedPage.closeComment" />
                  )}
                </li>
              ) : null}
            </ul>
          </div>
        ) : null}
      </OutsideClickHandler>
    </div>
  );
};

export default PostOptionsMenu;
